(function() {
  'use strict';
  
  const config = window.TranscySuppressConfig || {};
  const shopCountry = config.shopCountry || '';
  let userCountry = '';
  
  function hideTranscyModal() {
    // Restore scrolling - Transcy locks body when modal opens
    const html = document.documentElement;
    const body = document.body;
    
    if (html) {
      html.classList.remove('transcy-modal-opened');
      html.removeAttribute('hidden');
      html.removeAttribute('aria-hidden');
      if (html.style.overflow === 'hidden') html.style.overflow = '';
    }
    
    if (body) {
      body.style.overflow = '';
      body.style.overflowY = '';
      body.removeAttribute('hidden');
      body.removeAttribute('aria-hidden');
    }
    
    // Hide modal elements
    const selectors = ['#transcy-geo', '#transcy-modal-backdrop', '.transcy-modal-backdrop', '.transcy-modal:not(html)', '.transcy-select-modal:not(html)', '.transcy-modal-dialog:not(html)'];
    
    selectors.forEach(sel => {
      try {
        document.querySelectorAll(sel).forEach(el => {
          if (el.tagName === 'HTML' || el.tagName === 'BODY') return;
          el.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;position:fixed!important;z-index:-9999!important;';
          el.setAttribute('hidden', '');
          el.setAttribute('aria-hidden', 'true');
        });
      } catch(e) {}
    });
    
    // Hide backdrops
    try {
      document.querySelectorAll('#transcy-modal-backdrop, .transcy-modal-backdrop, [class*="transcy"][class*="backdrop"]:not(html), [class*="transcy"][class*="overlay"]:not(html)').forEach(el => {
        if (el.tagName === 'HTML' || el.tagName === 'BODY') return;
        el.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;';
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      });
    } catch(e) {}
  }
  
  function checkAndKillModal(country) {
    const isDisabled = country && country === shopCountry;
    if (!isDisabled) return false;
    
    hideTranscyModal();
    
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        // Watch for class/style changes on html/body
        if (m.type === 'attributes') {
          const target = m.target;
          if (target === document.documentElement && target.classList.contains('transcy-modal-opened')) {
            hideTranscyModal();
          } else if ((target === document.documentElement || target === document.body) && 
                     (target.style.overflow === 'hidden' || target.style.overflowY === 'hidden')) {
            hideTranscyModal();
          }
        }
        
        // Watch for added modal nodes
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches && (
            node.matches('[id^="transcy-modal"]') || node.matches('.transcy-modal') ||
            node.matches('.transcy-select-modal') || node.matches('.transcy-modal-dialog') ||
            node.classList.contains('transcy-modal')
          )) {
            hideTranscyModal();
          }
          const modals = node.querySelectorAll?.('[id^="transcy-modal"], .transcy-modal, .transcy-select-modal, .transcy-modal-dialog');
          if (modals?.length) hideTranscyModal();
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    
    const interval = setInterval(hideTranscyModal, 100);
    setTimeout(() => { clearInterval(interval); observer.disconnect(); }, 10000);
    
    // Override Transcy API if available
    if (window.Transcy) {
      if (window.Transcy.showModal) {
        window.Transcy.showModal = () => false;
      }
      if (window.Transcy.setLocation && config.language && config.currency) {
        window.Transcy.setLocation({
          country: country,
          language: config.language,
          currency: config.currency
        });
      }
    }
    return true;
  }
  
  // Detect user country using IP geolocation API
  let transcyDisabled = false;
  
  const CACHE_KEY = 'transcy_geo_cache';
  const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  
  function getCachedCountry() {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (!cached) return null;
      
      const { country, timestamp } = JSON.parse(cached);
      const now = Date.now();
      
      // Check if cache is still valid
      if (now - timestamp < CACHE_DURATION) {
        return country;
      }
      
      // Cache expired, remove it
      localStorage.removeItem(CACHE_KEY);
      return null;
    } catch(e) {
      return null;
    }
  }
  
  function setCachedCountry(country) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        country: country,
        timestamp: Date.now()
      }));
    } catch(e) {
      // localStorage might be disabled or full
    }
  }
  
  function logStatus(cacheNote) {
    console.log('Shop country:', shopCountry || '(not set)');
    console.log('User IP country:', userCountry || '(not detected)');
    console.log('Transcy modal:', transcyDisabled ? 'DISABLED' : 'ENABLED');
    if (cacheNote) {
      console.log('Note:', cacheNote);
    }
  }
  
  // Use IP geolocation API to detect user country
  if (shopCountry) {
    // Check cache first
    const cachedCountry = getCachedCountry();
    
    if (cachedCountry) {
      // Use cached country
      userCountry = cachedCountry.toLowerCase();
      transcyDisabled = checkAndKillModal(userCountry);
      logStatus('Using cached country (no API call)');
    } else {
      // Make API call
      // Note: ipapi.co free tier doesn't expose quota info in response headers
      fetch('https://ipapi.co/json/')
        .then(r => r.json())
        .then(data => {
          if (data.country_code) {
            userCountry = data.country_code.toLowerCase();
            setCachedCountry(userCountry);
            transcyDisabled = checkAndKillModal(userCountry);
          }
          logStatus();
        })
        .catch(() => {
          // If API fails, assume match to prevent modal
          transcyDisabled = checkAndKillModal(shopCountry);
          logStatus();
        });
    }
  } else {
    logStatus();
  }
  
  // Backup on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (userCountry === shopCountry && !transcyDisabled) {
        hideTranscyModal();
        transcyDisabled = true;
        logStatus();
      }
    });
  } else {
    if (userCountry === shopCountry && !transcyDisabled) {
      hideTranscyModal();
      transcyDisabled = true;
      logStatus();
    }
  }
})();

